import React from 'react'

const LoadingRemove = () => {
    return (
        <></>
    )
}

export default LoadingRemove